import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const JobsPageBannerSection = ({ className, pathPrefix, variant }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`${pathPrefix}.banner.title.${locale}`} tag="h1" />}
      image={{ path: `${pathPrefix}.banner.image`, src: "/assets/banners/jobs.webp" }}
      variant={variant}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`${pathPrefix}.banner.text.${locale}`} className="mb-5" />
        </Col>
      </Row>
    </Banner>
  );
};

JobsPageBannerSection.defaultProps = {
  variant: "primary",
  pathPrefix: "page.jobs",
};
